module.exports = __webpack_public_path__ + "static/img/ARADIN2_2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ARADIN2_2.png
// module id = mGW7
// module chunks = 0